import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
} from "reactstrap";
import { Link } from 'react-router-dom';
import "../../assets/css/service.css";
import "bootstrap/dist/css/bootstrap.min.css";


export default function Service() {
    const services = [
        {
            title: "Custom Designs",
            description: "Get any design made your way with expedited delivery.",
            icon: "/assets/images/services/img_20251001.jpg",
        },
        {
            title: "Media Support",
            description: "Whether you require images, CADs or renders, we are here to help you.",
            icon: "/assets/images/services/width_201.png",
        },
        {
            title: "Bin Stock Service",
            description: "Get Online access to our ready inventory. Delivered in 24 Hours",
            icon: "/assets/images/services/width_200.jpg",
        },
        {
            title: "Market Insights",
            description: "Get Product Level market insights based on location and other factors.",
            icon: "/assets/images/services/img_20251007.jpg",
        },
        {
            title: "Dropshipping Support",
            description: "Upload our styles on your website. Let us do the fulfillment",
            icon: "/assets/images/services/width_205.png",
        },
        {
            title: "Customer Portal",
            description: "Get Access to our customer portal with over 4000 designs.",
            icon: "/assets/images/services/img_20251003.png",
        },
        {
            title: "Bulk Orders",
            description: "With our manufacturing capacity, we can handle large orders with consistent quality",
            icon: "/assets/images/services/width_210.jpg",
        },


    ];

    document.title = "Services";
    return (
        <Container className="text-center service-container">
            <h1 className="mb-5 pb-3 fw-bold text-primary">
                One Partner For All Your Backend Needs.
            </h1>
            <Row className=" justify-content-center card-Display">

                {services.map((service, index) => (
                    <Col key={index} xs="8" sm="6" md="4" lg="3" className="d-flex justify-content-center " style={{ padding: "2px" }}>
                        <div className="service-card">
                            <img src={service.icon} alt={service.title} className="service-icon" />
                            <h3 className="fw-bold">{service.title}</h3>
                            <p className="description-text">{service.description}</p>
                        </div>
                    </Col>
                ))}

                <h2 className="mb-3 fw-bold text-primary p-5 m-5">
                    Purchase Smarter and Faster. One Portal. Many Options.
                </h2>

                <div className="col-12 col-md-10 d-flex justify-content-center">
                    <div className="pc-video-container position-relative mx-auto">
                        <img
                            src="/assets/images/home/advantages5.png"
                            alt="PC Frame"
                            className="pc-frame img-fluid"
                        />
                        <video
                            className="pc-screen-video position-absolute"
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source src="/assets/videos/Advantages.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>

                <div style={{ marginTop: "40px", fontSize: "16px", color: "#000" }} data-aos="fade-up">
                    <p>
                        With Our Custom Portal You can get access to 4000+ designs. Make selections and <br></br> connect with our representatives for fast order placing.
                    </p>
                </div>


            </Row>
            <Row className="align-items-center service-section mb-5 gx-5" style={{ marginTop: "30px" }}>
                <Col md="6" className="text-center">
                    <img
                        src="/assets/images/services/dorshipping.jpg"
                        alt="Dropshipping Support"
                        className="img-fluid service-image-Dropshipping"
                    />
                </Col>
                <Col md="6">
                    <div className="fw-bold text-primary service-title-main" data-aos="fade-up">Dropshipping Support</div>
                    <div className="service-subtitle text-primary" data-aos="fade-up">How it Works</div>
                    <ul className="service-list text-primary" data-aos="fade-up">
                        <li className="">We integrate your platform through an API</li>
                        <li className="">List our designs on your platform</li>
                        <li className="">Receive orders</li>
                        <li className="">We fulfill and ship your order on time</li>
                    </ul>
                </Col>
            </Row>


            <Row className="align-items-center service-section flex-md-row-reverse">
                <Col md="6" className="text-center" data-aos="fade-left">
                    <img
                        src="/assets/images/services/img_20251002.png"
                        alt="Custom Design Support"
                        className="img-fluid service-image"
                    />
                </Col>
                <div className="custom-support col-md-6 text-center mb-4 mb-md-0 order-2 order-md-2" data-aos="fade-right">
                    <h2 className="mb-3 fw-bold text-primary" >
                        Custom Design Support
                    </h2>
                    <p className="service-description text-primary" >
                        Making jewellery is a craft we love. And we understand how important
                        and special jewellery purchases are for consumers. With cutting edge
                        technology and seasoned artisans, we put our minds and souls into
                        making breathtaking pieces of jewelry.
                    </p>
                    <Link to="/contact-us" className="aboutusBtns bg-primary inline-block text-center">
                        Contact Us
                    </Link>
                </div>
            </Row>


            <Row className="align-items-center service-section">
                <Col md="6" className="text-center" data-aos="fade-right">
                    <img
                        src="/assets/images/services/binstock.jpg"
                        alt="Bin Stock Support"
                        className="img-fluid binstock-image"

                    />
                </Col>
                <div className="col-md-6 text-center  order-2 order-md-2 service-section-desc" data-aos="fade-left">
                    <h3 className="section-subtitle text-primary" style={{ fontWeight: "bold", fontSize: "30px", }}>
                        Bin Stock Support
                    </h3>
                    <h6 className="text-primary service-subtitile-description">
                        Get Access to ready-to-ship styles. Shipped in 24 hours
                    </h6>
                    <p className="text-primary text-center service-description">
                        You can Access our ready to ship inventory
                        directly on our website and place orders to fulfill
                        sensitive merchandise gaps for your store and gain additional sales.
                    </p>
                    <Link to="/bin-stock" className="aboutusBtns bg-primary inline-block text-center">
                        Go To Bin Stock
                    </Link>
                </div>
            </Row>
        </Container>
    );
}
